/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AlertExecutionDto } from '../models/alert-execution-dto';
import { AlertRuleDto } from '../models/alert-rule-dto';
import { alertsAlertRuleIdHistoryGet$Json } from '../fn/alerts/alerts-alert-rule-id-history-get-json';
import { AlertsAlertRuleIdHistoryGet$Json$Params } from '../fn/alerts/alerts-alert-rule-id-history-get-json';
import { alertsAlertRuleIdHistoryGet$Plain } from '../fn/alerts/alerts-alert-rule-id-history-get-plain';
import { AlertsAlertRuleIdHistoryGet$Plain$Params } from '../fn/alerts/alerts-alert-rule-id-history-get-plain';
import { alertsPost$Json } from '../fn/alerts/alerts-post-json';
import { AlertsPost$Json$Params } from '../fn/alerts/alerts-post-json';
import { alertsPost$Plain } from '../fn/alerts/alerts-post-plain';
import { AlertsPost$Plain$Params } from '../fn/alerts/alerts-post-plain';
import { alertsQueryQueryDefinitionIdGet$Json } from '../fn/alerts/alerts-query-query-definition-id-get-json';
import { AlertsQueryQueryDefinitionIdGet$Json$Params } from '../fn/alerts/alerts-query-query-definition-id-get-json';
import { alertsQueryQueryDefinitionIdGet$Plain } from '../fn/alerts/alerts-query-query-definition-id-get-plain';
import { AlertsQueryQueryDefinitionIdGet$Plain$Params } from '../fn/alerts/alerts-query-query-definition-id-get-plain';

@Injectable({ providedIn: 'root' })
export class AlertsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `alertsPost()` */
  static readonly AlertsPostPath = '/alerts';

  /**
   * Create alert rule.
   *
   * Creates a threshold rule for a query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alertsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  alertsPost$Plain$Response(params?: AlertsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertRuleDto>> {
    const obs = alertsPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create alert rule.
   *
   * Creates a threshold rule for a query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `alertsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  alertsPost$Plain(params?: AlertsPost$Plain$Params, context?: HttpContext): Observable<AlertRuleDto> {
    const resp = this.alertsPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AlertRuleDto>): AlertRuleDto => r.body)
    );
  }

  /**
   * Create alert rule.
   *
   * Creates a threshold rule for a query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alertsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  alertsPost$Json$Response(params?: AlertsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertRuleDto>> {
    const obs = alertsPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create alert rule.
   *
   * Creates a threshold rule for a query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `alertsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  alertsPost$Json(params?: AlertsPost$Json$Params, context?: HttpContext): Observable<AlertRuleDto> {
    const resp = this.alertsPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AlertRuleDto>): AlertRuleDto => r.body)
    );
  }

  /** Path part for operation `alertsQueryQueryDefinitionIdGet()` */
  static readonly AlertsQueryQueryDefinitionIdGetPath = '/alerts/query/{queryDefinitionId}';

  /**
   * List alerts for query.
   *
   * Returns all alert rules for a specific query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alertsQueryQueryDefinitionIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  alertsQueryQueryDefinitionIdGet$Plain$Response(params: AlertsQueryQueryDefinitionIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertRuleDto>>> {
    const obs = alertsQueryQueryDefinitionIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List alerts for query.
   *
   * Returns all alert rules for a specific query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `alertsQueryQueryDefinitionIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  alertsQueryQueryDefinitionIdGet$Plain(params: AlertsQueryQueryDefinitionIdGet$Plain$Params, context?: HttpContext): Observable<Array<AlertRuleDto>> {
    const resp = this.alertsQueryQueryDefinitionIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AlertRuleDto>>): Array<AlertRuleDto> => r.body)
    );
  }

  /**
   * List alerts for query.
   *
   * Returns all alert rules for a specific query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alertsQueryQueryDefinitionIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  alertsQueryQueryDefinitionIdGet$Json$Response(params: AlertsQueryQueryDefinitionIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertRuleDto>>> {
    const obs = alertsQueryQueryDefinitionIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List alerts for query.
   *
   * Returns all alert rules for a specific query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `alertsQueryQueryDefinitionIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  alertsQueryQueryDefinitionIdGet$Json(params: AlertsQueryQueryDefinitionIdGet$Json$Params, context?: HttpContext): Observable<Array<AlertRuleDto>> {
    const resp = this.alertsQueryQueryDefinitionIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AlertRuleDto>>): Array<AlertRuleDto> => r.body)
    );
  }

  /** Path part for operation `alertsAlertRuleIdHistoryGet()` */
  static readonly AlertsAlertRuleIdHistoryGetPath = '/alerts/{alertRuleId}/history';

  /**
   * Get alert history.
   *
   * Returns recent executions for an alert rule.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alertsAlertRuleIdHistoryGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  alertsAlertRuleIdHistoryGet$Plain$Response(params: AlertsAlertRuleIdHistoryGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertExecutionDto>>> {
    const obs = alertsAlertRuleIdHistoryGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get alert history.
   *
   * Returns recent executions for an alert rule.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `alertsAlertRuleIdHistoryGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  alertsAlertRuleIdHistoryGet$Plain(params: AlertsAlertRuleIdHistoryGet$Plain$Params, context?: HttpContext): Observable<Array<AlertExecutionDto>> {
    const resp = this.alertsAlertRuleIdHistoryGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AlertExecutionDto>>): Array<AlertExecutionDto> => r.body)
    );
  }

  /**
   * Get alert history.
   *
   * Returns recent executions for an alert rule.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alertsAlertRuleIdHistoryGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  alertsAlertRuleIdHistoryGet$Json$Response(params: AlertsAlertRuleIdHistoryGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertExecutionDto>>> {
    const obs = alertsAlertRuleIdHistoryGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get alert history.
   *
   * Returns recent executions for an alert rule.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `alertsAlertRuleIdHistoryGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  alertsAlertRuleIdHistoryGet$Json(params: AlertsAlertRuleIdHistoryGet$Json$Params, context?: HttpContext): Observable<Array<AlertExecutionDto>> {
    const resp = this.alertsAlertRuleIdHistoryGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AlertExecutionDto>>): Array<AlertExecutionDto> => r.body)
    );
  }

}
